import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Introducere', href: '#introducere' },
  { label: 'Concepte', href: '#concepte' },
  { label: 'Instrumente', href: '#instrumente' },
  { label: 'Strategii', href: '#strategii' },
  { label: 'Risc', href: '#risc' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: '#4ecdc4' }}>
            <i className="ri-line-chart-line text-white text-lg"></i>
          </div>
          <span
            className="text-xl font-bold tracking-tight"
            style={{ fontFamily: 'Playfair Display, serif', color: scrolled ? '#0f1419' : '#0f1419' }}
          >
            FX<span style={{ color: '#4ecdc4' }}>Learn</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className="text-sm font-medium uppercase tracking-wider transition-colors duration-200 cursor-pointer"
                style={{ color: scrolled ? '#2d3748' : '#0f1419' }}
                onMouseEnter={(e) => ((e.target as HTMLElement).style.color = '#4ecdc4')}
                onMouseLeave={(e) => ((e.target as HTMLElement).style.color = scrolled ? '#2d3748' : '#0f1419')}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <a
          href="https://clicks.affstrack.com/c?c=1197206&l=ja&p=1"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="hidden md:flex items-center gap-2 px-5 py-2 rounded-full text-white text-sm font-semibold whitespace-nowrap transition-opacity duration-200 hover:opacity-90 cursor-pointer"
          style={{ background: '#0f1419' }}
        >
          Începe Acum
          <i className="ri-arrow-right-line"></i>
        </a>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} style={{ color: '#0f1419' }}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => handleNav(e, link.href)}
                  className="text-sm font-medium uppercase tracking-wider text-gray-700 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}
